/*
 * @Author: Nora Galvin
 * @Date: 2020-08-17 10:49:50
 * @Last Modified by: Nora
 * @Last Modified time: 2020-09-03 11:20:19
 */
import template from '@/app/editor/sidebar/templates/gfElement/textarea.html';

export const textareaSettings = [
  {
    name: 'name',
    caption: 'Name',
    type: 'text',
    class: 'name',
    target: '.gf_textfield',
    ref: 'attr|name',
  },
  {
    name: 'tf-placeholder',
    caption: 'Placeholder',
    type: 'text',
    class: 'placeholder',
    value: '',
    desc: 'Placeholder to show inside input field.',
    target: '.gf_textfield',
    ref: 'attr|placeholder',
  },
  {
    name: 'required',
    id: 'required',
    class: 'gf_to-switch',
    caption: 'Required',
    type: 'input',
    default_value: '0',
    desc: 'Make this field required.',
    target: '.gf_textfield',
    ref: 'attr|required',
  },
  {
    caption: 'Dimension',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'width',
        caption: 'Width',
        type: 'text',
        unit: '%',
        class: 'width spinner',
        value: '',
        mode: 'responsive-mode',
        target: '.gf_textfield',
        ref: 'css|width',
      },
      {
        name: 'height',
        caption: 'Height',
        type: 'text',
        unit: 'px',
        class: 'height spinner',
        mode: 'responsive-mode',
        target: '.gf_textfield',
        ref: 'css|height',
      },
    ],
  },
  {
    caption: 'Typography',
    type: 'group',
    mode: 'responsive-mode',
    items: [
      {
        name: 'fontWeight',
        id: 'fontWeight',
        caption: 'Font Weight',
        type: 'select',
        options: {
          '100': 'Thin 100',
          '200': 'Semi Thin 200',
          '300': 'Light 300',
          '400': 'Regular 400',
          '500': 'Medium 500',
          '600': 'Semi Bold 600',
          bold: 'Bold 700',
          '800': 'Super Bold 800',
          '900': 'Boldest 900',
          lighter: 'Lighter',
          bolder: 'Bolder',
        },
        default_value: '400',
        mode: 'responsive-mode',
        ref: 'css|font-weight',
        target: '.gf_textfield',
      },
      {
        caption: 'Font Size',
        name: 'font-size',
        id: 'font-size',
        type: 'text',
        class: 'gf_to-range',
        min: '8',
        max: '72',
        step: '1',
        unit: 'px',
        default_value: '14px',
        mode: 'resonsive-mode',
        target: '.gf_textfield',
        ref: 'css|font-size',
      },
      {
        name: 'font',
        id: 'font',
        class: 'gf_font',
        caption: 'Font',
        type: 'text',
        default_value: '',
        mode: 'resonsive-mode',
        target: '.gf_textfield',
        ref: 'css|font-family',
      },
      {
        name: 'text-color',
        caption: 'Text Color',
        type: 'text',
        id: 'text-color',
        class: 'textcolor gryff-color',
        mode: 'resonsive-mode',
        target: '.gf_textfield',
        ref: 'css|color',
      },
    ],
  },
  {
    id: 'alignment',
    name: 'alignment',
    class: 'gf_to-align',
    caption: 'Alignment',
    type: 'select',
    options: {
      left: 'Left',
      center: 'Center',
      right: 'Right',
    },
    mode: 'responsive-mode',
    target: '.elm',
    ref: 'class|align',
  },
  {
    name: 'extra_class',
    caption: 'Extra Class',
    type: 'text',
    desc: 'If you wish to style particular content element differently, then use this field to add a class name and then refer to it in your css file.',
    target: '.gf_textfield',
    ref: 'class|classname',
  },
];

export default {
  name: 'Text Area',
  slug: 'text-area',
  class: 'gf_textarea',
  id: 'md-text-area',
  html: template(),
  settings: textareaSettings,
};
